angular.module('bribac.components.agentEditor', [
  'bribac.translations',
  'bribac.values',
  'bribac.entities.kinds',
  'bribac.services.api',
  'bribac.services.filterUtils',
  'bribac.components.whenLoaded',
  'bribac.components.mainGroupSubGroupPicker'
])

  .component('agentEditor', {
    templateUrl: 'agent-editor-component.html',
    controller: 'AgentEditorComponentCtrl',
    bindings: {
      form: '<',
      agent: '<'
    }
  })

  .controller('AgentEditorComponentCtrl', function(
    KINDS,
    PHONE_NUMBER_REGEX,
    api,
    permissions,
    state,
    availableLocales,
    filterUtils
  ) {
    var $ctrl = this

    $ctrl.permissions = permissions
    $ctrl.PHONE_NUMBER_REGEX = PHONE_NUMBER_REGEX
    $ctrl.state = state
    $ctrl.availableLocales = Object.keys(availableLocales)

    $ctrl.notifyAgentOptions = [
      {prop: 'notifyAgentBySms', i18n: 'sms'},
      {prop: 'notifyAgentByMail', i18n: 'email'},
    ]

    $ctrl.setRole = function(role) {
      $ctrl.agent.roles = [role]
    }

    $ctrl.hasOrganization = function() {
      return !!$ctrl.agent.organization
    }

    $ctrl.handleOrganizationChange = function() {
      // Clear group selection
      $ctrl.agent.subGroups = []
      loadGroups()
    }

    function loadGroups() {
      var filter = ''
      if ($ctrl.hasOrganization()) {
        filter = '?organization=' + $ctrl.agent.organization.id
      }
      $ctrl.mainGroupsPromise = api.getFilteredByOrg(KINDS.MAIN_GROUP, filter).then(function(request) {
        $ctrl.mainGroups = request.data.list

        // We need to use the sub groups returned by the main groups promise
        // since that is what's used to list the sub groups in the template,
        // otherwise the ng-checked won't match and the sub group selection
        // won't be restored when editing an agent.
        var currentSubGroupIds = $ctrl.agent.subGroups.map(function(subGroup) {
          return subGroup.id
        })
        $ctrl.mainGroups.forEach(function(mainGroup) {
          mainGroup.subGroups.forEach(function(subGroup) {
            subGroup.isChecked = currentSubGroupIds.indexOf(subGroup.id) > -1
          })
          mainGroup.isChecked = mainGroup.subGroups.every(function (subGroup) {
            return subGroup.isChecked
          })
        })
      })
    }

    $ctrl.deleteAgent = function() {
      if (confirm('Are you sure you want to delete this agent?')) {
        api.delete(KINDS.AGENT, $ctrl.agent.id)
          .then(function() {
            $uibModal.open({
              template: '<div class="modal-body">Agent ' +
                ($ctrl.agent.fullName || ($ctrl.agent.firstName + ' ' + $ctrl.agent.lastName)) +
                ' (ID: ' + $ctrl.agent.id + ') deleted successfully.</div>',
              size: 'sm'
            });
          }, function(error) {
            $uibModal.open({
              template: '<div class="modal-body">Error deleting agent ' +
                ($ctrl.agent.fullName || ($ctrl.agent.firstName + ' ' + $ctrl.agent.lastName)) +
                ' (ID: ' + $ctrl.agent.id + '): ' +
                (error.data && error.data.errorMessage
                  ? error.data.errorMessage
                  : (error.statusText || 'Unknown error')) +
                '</div>',
              size: 'sm'
            });
          });
      }
    };

    // Init.

    $ctrl.$onInit = function() {
      if (!$ctrl.permissions.canManageOrganizations()){
        $ctrl.agent.organization = state.currentAgent.organization
      } else {
        $ctrl.organizationsPromise = api.get(KINDS.ORGANIZATION).then(function(request) {
          $ctrl.organizations = filterUtils.filterOrganizations('active', request.data.list)
        })
      }

      $ctrl.rolesPromise = api.getAssignableAgentRoles().then(function(request) {
        $ctrl.roles = request.data
        // If a role is already set and it's not available among the rules that
        // the current admin is allowed to set then we should not be allowed to
        // change away from it.
        var currentRole = $ctrl.agent.roles[0]
        $ctrl.currentRoleLocked = currentRole && $ctrl.roles.indexOf(currentRole) < 0
        if ($ctrl.currentRoleLocked) {
          $ctrl.roles.push(currentRole)
        }
      })

      loadGroups()
    }
  })
